/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 保存波次校验配置 的 **请求配置**
 *
 * @分类 #3897_波次校验前称重
 * @请求头 `POST /erp/WavePicking/diffStockoutSettingSave`
 */
const postDiffStockoutSettingSaveRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WavePicking/diffStockoutSettingSave",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postDiffStockoutSettingSave",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 保存波次校验配置 的 **请求函数**
 *
 * @分类 #3897_波次校验前称重
 * @请求头 `POST /erp/WavePicking/diffStockoutSettingSave`
 */
export const postDiffStockoutSettingSave = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postDiffStockoutSettingSaveRequestConfig, requestData),
    ...args
  );
};
postDiffStockoutSettingSave.requestConfig =
  postDiffStockoutSettingSaveRequestConfig;
/**
 * 接口 获取波次校验配置 的 **请求配置**
 *
 * @分类 #3897_波次校验前称重
 * @请求头 `POST /erp/WavePicking/diffStockoutSettingGet`
 */
const postDiffStockoutSettingGetRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WavePicking/diffStockoutSettingGet",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postDiffStockoutSettingGet",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取波次校验配置 的 **请求函数**
 *
 * @分类 #3897_波次校验前称重
 * @请求头 `POST /erp/WavePicking/diffStockoutSettingGet`
 */
export const postDiffStockoutSettingGet = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postDiffStockoutSettingGetRequestConfig, requestData),
    ...args
  );
};
postDiffStockoutSettingGet.requestConfig =
  postDiffStockoutSettingGetRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 分离设置 的 **请求配置**
 *
 * @分类 #4364
 * @请求头 `POST /erp/WavePicking/onlyDabiaoSetting`
 */
const postOnlyDabiaoSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/WavePicking/onlyDabiaoSetting",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postOnlyDabiaoSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 分离设置 的 **请求函数**
 *
 * @分类 #4364
 * @请求头 `POST /erp/WavePicking/onlyDabiaoSetting`
 */
export const postOnlyDabiaoSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postOnlyDabiaoSettingRequestConfig, requestData),
    ...args
  );
};
postOnlyDabiaoSetting.requestConfig = postOnlyDabiaoSettingRequestConfig;
/**
 * 接口 获取分离设置 的 **请求配置**
 *
 * @分类 #4364
 * @请求头 `GET /erp/WavePicking/onlyDabiaoSetting`
 */
const getOnlyDabiaoSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/WavePicking/onlyDabiaoSetting",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getOnlyDabiaoSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取分离设置 的 **请求函数**
 *
 * @分类 #4364
 * @请求头 `GET /erp/WavePicking/onlyDabiaoSetting`
 */
export const getOnlyDabiaoSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getOnlyDabiaoSettingRequestConfig, requestData),
    ...args
  );
};
getOnlyDabiaoSetting.requestConfig = getOnlyDabiaoSettingRequestConfig;
const mockUrl_0_0_0_2 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_2 = "";
const prodUrl_0_0_0_2 = "";
const dataKey_0_0_0_2 = "data";
/**
 * 接口 囤货波次出库拣货 的 **请求配置**
 *
 * @分类 #4386
 * @请求头 `POST /erp/WavePicking/stockWpOutPicking`
 */
const postStockWpOutPickingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/WavePicking/stockWpOutPicking",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postStockWpOutPicking",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 囤货波次出库拣货 的 **请求函数**
 *
 * @分类 #4386
 * @请求头 `POST /erp/WavePicking/stockWpOutPicking`
 */
export const postStockWpOutPicking = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postStockWpOutPickingRequestConfig, requestData),
    ...args
  );
};
postStockWpOutPicking.requestConfig = postStockWpOutPickingRequestConfig;
/**
 * 接口 波次分播设置 的 **请求配置**
 *
 * @分类 #4386
 * @请求头 `GET /erp/WavePicking/CutSetting`
 */
const getCutSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/WavePicking/CutSetting",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getCutSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 波次分播设置 的 **请求函数**
 *
 * @分类 #4386
 * @请求头 `GET /erp/WavePicking/CutSetting`
 */
export const getCutSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getCutSettingRequestConfig, requestData), ...args);
};
getCutSetting.requestConfig = getCutSettingRequestConfig;
/**
 * 接口 设置囤货波次自动上架功能开关 的 **请求配置**
 *
 * @分类 #4386
 * @请求头 `POST /erp/WavePicking/setStockWavePickingSwitch`
 */
const postSetStockWavePickingSwitchRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/WavePicking/setStockWavePickingSwitch",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetStockWavePickingSwitch",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置囤货波次自动上架功能开关 的 **请求函数**
 *
 * @分类 #4386
 * @请求头 `POST /erp/WavePicking/setStockWavePickingSwitch`
 */
export const postSetStockWavePickingSwitch = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSetStockWavePickingSwitchRequestConfig, requestData),
    ...args
  );
};
postSetStockWavePickingSwitch.requestConfig =
  postSetStockWavePickingSwitchRequestConfig;
/**
 * 接口 获取囤货波次自动上架功能开关 的 **请求配置**
 *
 * @分类 #4386
 * @请求头 `GET /erp/WavePicking/getStockWavePickingSwitch`
 */
const getGetStockWavePickingSwitchRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/WavePicking/getStockWavePickingSwitch",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetStockWavePickingSwitch",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取囤货波次自动上架功能开关 的 **请求函数**
 *
 * @分类 #4386
 * @请求头 `GET /erp/WavePicking/getStockWavePickingSwitch`
 */
export const getGetStockWavePickingSwitch = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(getGetStockWavePickingSwitchRequestConfig, requestData),
    ...args
  );
};
getGetStockWavePickingSwitch.requestConfig =
  getGetStockWavePickingSwitchRequestConfig;
const mockUrl_0_0_0_3 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_3 = "";
const prodUrl_0_0_0_3 = "";
const dataKey_0_0_0_3 = "data";
/**
 * 接口 导入订单生成波次 的 **请求配置**
 *
 * @分类 #5306
 * @请求头 `POST /erp/WavePicking/importAllotOrder`
 */
const postImportAllotOrderRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_3,
  devUrl: devUrl_0_0_0_3,
  prodUrl: prodUrl_0_0_0_3,
  path: "/erp/WavePicking/importAllotOrder",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportAllotOrder",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入订单生成波次 的 **请求函数**
 *
 * @分类 #5306
 * @请求头 `POST /erp/WavePicking/importAllotOrder`
 */
export const postImportAllotOrder = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postImportAllotOrderRequestConfig, requestData),
    ...args
  );
};
postImportAllotOrder.requestConfig = postImportAllotOrderRequestConfig;
const mockUrl_0_0_0_4 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_4 = "";
const prodUrl_0_0_0_4 = "";
const dataKey_0_0_0_4 = "data";
/**
 * 接口 获取波次详情对应的rec_id是否配齐 的 **请求配置**
 *
 * @分类 5365
 * @请求头 `POST /erp/WavePicking/getWavePickingInfoRecAllot`
 */
const postGetWavePickingInfoRecAllotRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/WavePicking/getWavePickingInfoRecAllot",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetWavePickingInfoRecAllot",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取波次详情对应的rec_id是否配齐 的 **请求函数**
 *
 * @分类 5365
 * @请求头 `POST /erp/WavePicking/getWavePickingInfoRecAllot`
 */
export const postGetWavePickingInfoRecAllot = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetWavePickingInfoRecAllotRequestConfig, requestData),
    ...args
  );
};
postGetWavePickingInfoRecAllot.requestConfig =
  postGetWavePickingInfoRecAllotRequestConfig;
const mockUrl_0_0_0_5 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_5 = "";
const prodUrl_0_0_0_5 = "";
const dataKey_0_0_0_5 = "data";
/**
 * 接口 删除网点信息 的 **请求配置**
 *
 * @分类 5847
 * @请求头 `POST /erp/WavePicking/delSender`
 */
const postDelSenderRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_5,
  devUrl: devUrl_0_0_0_5,
  prodUrl: prodUrl_0_0_0_5,
  path: "/erp/WavePicking/delSender",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_5,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postDelSender",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 删除网点信息 的 **请求函数**
 *
 * @分类 5847
 * @请求头 `POST /erp/WavePicking/delSender`
 */
export const postDelSender = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postDelSenderRequestConfig, requestData), ...args);
};
postDelSender.requestConfig = postDelSenderRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/wavePicking.js